import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { BrowserModule } from "@angular/platform-browser";
import { es_ES, provideNzI18n } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations, BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {  provideNgxMask } from 'ngx-mask';
import { provideLottieOptions } from 'ngx-lottie';

import { ErrorCatchingInterceptorFn } from '@core/interceptors/error-catching-fn.interceptor';
import { TokenInterceptorFn } from '@core/interceptors/token-fn.interceptor';

registerLocaleData(es);

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideNzI18n(es_ES),
    provideAnimations(),
    provideNgxMask(),
    provideLottieOptions({
      player: () => import('lottie-web')
     }),
     provideHttpClient(

    ),
    importProvidersFrom([
      HttpClientModule,
      BrowserAnimationsModule,
      BrowserModule,
      FormsModule
    ]),
    provideHttpClient(withInterceptors([
      ErrorCatchingInterceptorFn,
      TokenInterceptorFn
    ])),
  ]
};
